import { env } from './.env';

export const environment = {
  production: true,
  ...env,
  // Token de Mapbox para mapas
  mapboxToken: (env as any).mapboxToken ?? null,
  version: (env as any).version ?? (env as any).npm_package_version ?? null,
  // API base (Angular 16 frontend expects /v1)
  serverUrl:
    (env as any).serverUrl ?? 'https://app.tbagrosensor.com/public/api/v1'
};
